/**
 * Los 4 pasos para que un negocio quede operando, en orden. Una sola definición:
 * la usan el modal "Configuración obligatoria" (page.jsx) y la sección "Primeros
 * pasos" (components/guia.jsx). El primer paso incompleto es el "actual".
 *
 * WhatsApp: se acepta 'authenticated' o 'ready' (los dos estados en los que la
 * sesión ya contesta), igual que hace el panel para decidir si está conectado.
 */
export const SETUP_STEPS = [
  { key: "schedule", label: "Horarios", tab: "schedule", check: (d) => Object.keys(d?.schedule?.workingHours || {}).length > 0 },
  { key: "services", label: "Servicios", tab: "services", check: (d) => (d?.business?.services?.length || 0) > 0 },
  { key: "google", label: "Google Calendar", tab: "connections", check: (d) => !!d?.staff?.some((s) => s.status === "ready") },
  { key: "whatsapp", label: "WhatsApp", tab: "connections", check: (d) => ["authenticated", "ready"].includes(d?.whatsintegration?.status) },
];

/** { done: boolean[], completed, total, currentIndex (-1 si todo listo), current (paso o null) } */
export function getSetupStatus(data) {
  const done = SETUP_STEPS.map((s) => !!s.check(data));
  const currentIndex = done.findIndex((ok) => !ok);
  return {
    done,
    completed: done.filter(Boolean).length,
    total: SETUP_STEPS.length,
    currentIndex,
    current: currentIndex === -1 ? null : SETUP_STEPS[currentIndex],
  };
}
